module.exports = __webpack_public_path__ + "static/media/on-AppStore.946de4fe.svg";